import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const EMAIL_REGEX =
  /^([A-Za-z0-9._+-]{1,64})@([A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*)\.([A-Za-z.]{2,})$/;

export function emailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value;
    if (!value) return null;

    if (!EMAIL_REGEX.test(value) || value.length > 256) {
      return { invalidFormat: true };
    }

    return null;
  };
}
